/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIGenerate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M8.5 1.5v2.813a2 2 0 0 0 2 2h3" /><path fill="currentColor" d="M12.802 15.92a.118.118 0 0 1-.224 0c-.215-.612-.348-.99-.565-1.314a3.1 3.1 0 0 0-.708-.747c-.313-.234-.683-.386-1.283-.634a.129.129 0 0 1 0-.238c.6-.248.97-.4 1.283-.635.276-.207.515-.46.708-.747.217-.324.35-.702.565-1.314a.118.118 0 0 1 .224 0c.215.612.348.99.565 1.314.192.287.432.54.708.747.313.234.682.387 1.283.635a.129.129 0 0 1 0 .238c-.6.248-.97.4-1.283.634-.276.208-.516.46-.708.747-.218.325-.35.702-.566 1.315" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M13.992 8.75V6.04a1 1 0 0 0-.293-.708L9.66 1.292A1 1 0 0 0 8.953 1h-5.96a1 1 0 0 0-1 1v1.125M1.992 6.047V9.39M9 15H7.547M5.438 15H3.906c-.515 0-1.914-.39-1.914-1.914v-1.524" /></svg>;
}
;